import { styled, theme } from '@/src/stitches.config'
import Button from '@/src/common/components/marketing/buttons/Button'

export const ComponentContent = styled('div', {
    m: 0,
    fontFamily: theme.fonts.default.value,
    '.bold': {
        fontWeight: 'bold',
    },
    '.active-button-gradient': {
        background: `linear-gradient(white, white) padding-box, linear-gradient(83.53deg, ${theme.colors.primary} 18.47%, ${theme.colors.secondary} 78%) border-box`,
        border: '2px solid transparent',
    },
})

export const BACContainer = styled('div', {
    display: 'flex',
    width: '1440px',
    maxWidth: '100%',
    margin: '0 auto',
    flexDirection: 'column',
    '@sm': {
        maxWidth: '100%',
    },
    '@md': {
        flexDirection: 'row',
    },
    '& h1': {
        '@media (max-width: 600px)': {
            fontSize: 32,
        },
        '@lg': {
            maxWidth: '600px',
        },
    },
    '.gradient': {
        background: `-webkit-linear-gradient(83.53deg, ${theme.colors.primary} 18.47%, ${theme.colors.secondary} 78%)`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
})

export const BACContainerLeft = styled('div', {
    bc: '$white',
    margin: '10px auto 25px auto',
    width: '100%',
    maxWidth: '90vw',
    position: 'relative',
    '.build-message': {
        marginTop: '2.5rem',
    },
    '@md': {
        width: '50%',
        p: '10px 40px 20px',
        maxWidth: 'unset',
    },
})

export const BACContainerRight = styled('div', {
    zIndex: 1,
    bc: '$lightest',
    py: '25px',
    px: '5%',
    width: '100%',
    maxWidth: '100%',
    '@md': {
        width: '50%',
        p: '30px 60px',
        maxWidth: 'unset',
    },
})

export const StyledList = styled('ul', {
    mt: 10,
    lh: '1.3rem',
    pl: 30,
    maxWidth: '95%',
    '& li': {
        mb: 5,
        fontSize: '.95rem',
    },
})

export const BACStep1Body = styled('div', {
    mt: '25px',
    letterSpacing: '.45px',
    '.build-message': {
        maxWidth: '350px',
        lineHeight: '23px',
    },
})

export const SmallGreyText = styled('p', {
    mt: '20px',
    mb: 0,
    fontSize: '.85rem',
    lineHeight: '1.4rem',
    color: '$mediumGray',
    maxWidth: '590px',
    '& a': {
        color: '$secondary',
    },
})

export const BackButton = styled('div', {
    display: 'inline-block',
    marginBottom: '30px',
    cursor: 'pointer',
    '&:hover': {
        color: '$primary',
        textDecoration: 'underline',
    },
})

export const CardImageButtonWrapper = styled('div', {
    display: 'flex',
    fd: 'column',
    '& button': {
        width: '100% !important',
        py: '35px',
        svg: {
            mr: '20px',
        },
    },
    variants: {
        variant: {
            wrap: {
                fd: 'row',
                minHeight: 'fit-content',
                height: 144,
                width: '100%',
                '& button': {
                    display: 'flex',
                    height: '100%',
                    minHeight: 'fit-content',
                    fd: 'column',
                    gap: 10,
                    svg: {
                        mr: 0,
                    },
                },
            },
        },
    },
})

export const CardImageButtonWrapperRow = styled('div', {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: '1rem',
    '& button': {
        width: '100% !important',
        height: 'auto',
        margin: '0px',
        py: '35px',
        '& svg': {
            mr: '20px',
        },
    },
})

export const DenomBoxWrapper = styled('div', {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 10,
    marginBottom: 15,
})

export const DenomBox = styled(Button, {
    width: '100% !important',
    margin: '0 !important',
    borderRadius: '5px',
    '@md': {
        borderRadius: '10px',
    },
})

export const AmountWrapper = styled('div', {
    '& button': {
        pl: '7px',
        pr: '7px',
    },
})

export const HeaderParagraphText = styled('p', {
    fontWeight: 'bold',
    fontSize: '$4',
    mt: 0,
    mb: 17,
    variants: {
        marginTop: {
            'add-margin': {
                mt: 17,
            },
        },
    },
})
